import { useCallback } from "react";
import { useNavigateToPostAuth } from "hooks/useNavigateToPostAuth";
import {
  LoanSelectionRouterParams,
  routeLoanSelection,
} from "utilities/loan-selection/LoanSelectionRouter";

export function useLoanSelectionRouter(): (params: LoanSelectionRouterParams) => void {
  const navigateToPostAuth = useNavigateToPostAuth();

  return useCallback(
    (params: LoanSelectionRouterParams) => {
      routeLoanSelection(params, navigateToPostAuth);
    },
    [navigateToPostAuth],
  );
}
